import React, { useState } from 'react';
import { BrioModal, BrioModalBody, BrioButton } from '../../components/BrioComponents';

// Confirm a hard delete of a library item. The real guard is server-side
// (boq.delete_library_item refuses if anything references the item); this only
// makes sure the click was deliberate and shows the refusal if one comes back.
function DeleteItemModal({ source, onDelete, onClose }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    setError(null);
    setSubmitting(true);
    const res = await onDelete();
    setSubmitting(false);
    if (res.success) onClose();
    else setError(res.error || 'Could not delete this item.');
  };

  const footer = (
    <>
      <BrioButton variant="secondary" onClick={onClose} disabled={submitting}>Cancel</BrioButton>
      <BrioButton variant="danger" onClick={handleDelete} disabled={submitting}>
        {submitting ? 'Deleting…' : 'Delete item'}
      </BrioButton>
    </>
  );

  return (
    <BrioModal title="Delete library item" onClose={onClose} width="md" footer={footer}>
      <BrioModalBody>
        {error && (
          <div style={{ padding: '0.75rem 1rem', background: '#fdecec', color: '#a94442', borderRadius: 6, marginBottom: '1rem' }}>
            {error}
          </div>
        )}
        <p style={{ margin: '0 0 0.75rem' }}>
          Delete <code style={{ fontWeight: 600 }}>{source.item.itemCode}</code>
          {source.description ? ` — ${source.description}` : ''}?
        </p>
        <p style={{ margin: '0 0 0.75rem', fontSize: '0.85rem', color: 'var(--brio-text-muted, #6b7280)', lineHeight: 1.5 }}>
          This removes the item and all {source.versionCount} of its versions for good. It goes through only
          while nothing references them: no rates, no project bill lines, no issued bill-version lines and no
          FF&amp;E schedule lines. If anything does, the delete is refused and you will be told what is holding it.
        </p>
        <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--brio-text-muted, #6b7280)', lineHeight: 1.5 }}>
          Any saved library version taken before now still holds this item, so restoring one brings it back.
        </p>
      </BrioModalBody>
    </BrioModal>
  );
}

export default DeleteItemModal;
